export const LENDERS_LIST = [
	'OPR',
	'CAPCITO',
	'QRED',
	'CAPITALBOX',
	'CREDIGO',
	'CORPIA',
	'AROSKAPITAL',
	'SVEA',
	'MARGINALEN',
	'DBT',
];

export const DEFAULT_MIN_LOAN_AMOUNTS = {
	EUR: 500,
	DKK: 5_000,
	SEK: 5_000,
};

//mapper for partners that have different id and key
//id is sent from the backend as line of credit - [partnerId]
//key is used in the FE for themes and client settings
export const PARTNER_ID_TO_KEY_MAPPER = {
	swedbankpay: 'swedbank-pay',
	worldline: 'worldline-se',
	'visma-lending': 'visma',
};

//Referral partners that are no longer allowed to start new onboarding sessions.
//Matched (case-insensitively) against the partner identifier in /apply/referral/:partner
export const BLOCKED_REFERRAL_PARTNERS = ['cloudfinans'];

export const DEFAULT_APP_LANGUAGE = 'sv';
export const DEFAULT_PARTNER_LANGUAGE = 'en';

export const PLACEHOLDER_SWEDISH_PHONE_NUMBER = '701 23 45 67';

//Unleash feature flags
export const CARD_BIN_CHECKING = 'CardBinChecking';
export const WL_KILL_SWITCH = 'WhiteLabelApplicationKillSwitch';
export const GENERAL_KILL_SWITCH = 'GeneralKillSwitch';
export const PARTNER_PORTAL_KILL_SWITCH = 'PartnerPortalKillSwitch';
export const ONBOARDING_KILL_SWITCH = 'OnboardingFlowKillSwitch';
export const CONTRACT_KILL_SWITCH = 'ContractKillSwitch';
export const DISABLED_FINAL_PAYMEMNT_FLAG = 'DisableFinalPaymentLs';
export const DISABLED_CHANGE_RATE_FLAG = 'DisableChangeRateLs';
export const DISABLED_PAUSE_LOAN_FLAG = 'DisablePauseLoanLs';
export const DISABLED_AMORTIZATION_FLAG = 'DisableAmortizationLs';

export const MEDIUM_BREAKPOINT = 640;
